import { Breakpoints, styled } from '@vw-marketing/us-components';

import { VWTheme } from '../../shared/typings/vw-theme';

export const MainLayoutContainer = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: start;
      display: flex;
      flex-direction: row;
      justify-content: start;
      width: ${theme.size.grid020};

      @media (min-width: ${Breakpoints.b1280}px) {
        gap: ${theme.size.grid001};
      }
    `;
  }}
`;

export const MainLayoutContent = styled.div`
  flex: 1;
  max-width: ${(props) => props.theme.size.grid020};
  @media (min-width: ${Breakpoints.b1280}px) {
    max-width: ${(props) => props.theme.size.grid014};
  }
`;

export const StyledRegistrationLayout: any = styled.div`
  ${({ theme }) => {
    return `
      width: ${theme.size.grid020};
      min-width: 200px;

      @media (min-width: ${Breakpoints.b560}px) {
        width: ${theme.size.grid012};
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        width: ${theme.size.grid008};
      }
    `;
  }}
`;
